module.exports = __webpack_public_path__ + "static/media/slices2@2x.ca47e429.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/slices2@2x.png
// module id = 761
// module chunks = 0 1